module.exports = function() {
  return new Worker(__webpack_public_path__ + "c4472f86ec529a2b5a62.worker.js");
};